import { CssBaseline, Grid2 as Grid, Paper } from '@mui/material'
import { ReactNode } from 'react'
import Footer from '../footer/Footer';

interface Props {
    bgLogin: string;
    children: ReactNode;
}
const LoginTemplate = ({ bgLogin, children }: Props) => {
    return (
        <Grid container component="main" sx={{ height: '100vh' }}>
            <CssBaseline />
            <Grid size={{ xs: false, sm: false, md: 5, lg: 5, xl: 5 }}
                sx={{
                    backgroundImage: `url(${bgLogin})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            >
            </Grid>

            <Grid size={{ xs: 12, sm: 12, md: 7, lg: 7, xl: 7 }} component={Paper} elevation={6} square
                sx={{
                    backgroundColor: '#F0F4FC',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    alignItems: 'center',

                }}
            >
                {children}
                <Footer />
            </Grid>
        </Grid>
    )

}

export default LoginTemplate;